import React from "react";
import { Button } from "antd";

interface PermissionViewProps {
  isLoading: boolean;
  onRequestPermission: () => void;
  onContinueWithoutPermission: () => void;
  onGoBack: () => void;
}

const PermissionView: React.FC<PermissionViewProps> = ({ isLoading, onRequestPermission, onContinueWithoutPermission, onGoBack }) => {
  if (isLoading) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
        <div className="text-center">
          <div className="w-12 h-12 mx-auto mb-4 border-b-2 rounded-full animate-spin border-primary"></div>
          <p className="text-gray-600">Requesting permissions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center p-5 bg-white">
      <div className="max-w-md text-center">
        <h1 className="mb-2 text-lg font-bold">Permission Required</h1>
        <p className="mb-6 text-sm text-gray-600">We need access to your device orientation to guide you during photo capture. You can upload photos from your gallery instead.</p>

        <div className="flex flex-col gap-3">
          <Button onClick={onRequestPermission} type="primary" block>
            Grant Permission
          </Button>
          <Button onClick={onContinueWithoutPermission} block>
            Upload from Gallery
          </Button>
          <Button onClick={onGoBack} type="text">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PermissionView;
